import { useEffect, useRef, useState } from "react";
import { message } from "antd";
import { useLocation, useParams } from "react-router-dom";
import { actualizarFirmasEvaluacion, getEvaluacionEmpleado } from "../shared/evaluacionesApi";

export function useDetalleEvaluacion() {
  const { evaluacionId } = useParams();
  const location = useLocation();
  const [evaluacion, setEvaluacion] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");
  const [firmante, setFirmante] = useState(null);
  const [guardandoFirma, setGuardandoFirma] = useState(false);
  const guardandoFirmaRef = useRef(false);
  const [revision, setRevision] = useState(0);

  useEffect(() => {
    let vigente = true;
    setCargando(true);
    setEvaluacion(null);
    setError("");
    setFirmante(null);
    getEvaluacionEmpleado(evaluacionId)
      .then(data => {
        if (vigente) setEvaluacion(data);
      })
      .catch(error => {
        if (vigente) setError(error.message);
      })
      .finally(() => {
        if (vigente) setCargando(false);
      });

    return () => {
      vigente = false;
    };
  }, [evaluacionId, revision]);

  const cerrarFirma = () => {
    if (guardandoFirmaRef.current) return;
    setFirmante(null);
  };

  const guardarFirma = async imagen => {
    if (guardandoFirmaRef.current) return;
    guardandoFirmaRef.current = true;
    setGuardandoFirma(true);
    try {
      const contenido = atob(imagen.split(",")[1]);
      const bytes = Uint8Array.from(contenido, caracter => caracter.charCodeAt(0));
      const archivo = new File([bytes], "firma.png", { type: "image/png" });
      const body = new FormData();
      body.append("EvaluacionEmpleadoID", String(evaluacion.id));
      body.append(firmante.campo, archivo);
      const resultado = await actualizarFirmasEvaluacion(body);
      message.success(resultado);
      setFirmante(null);
      setRevision(actual => actual + 1);
    } catch (error) {
      message.error(error.message);
    } finally {
      guardandoFirmaRef.current = false;
      setGuardandoFirma(false);
    }
  };

  return {
    evaluacionId,
    evaluacion,
    cargando,
    error,
    firmante,
    guardandoFirma,
    abrirFirma: setFirmante,
    cerrarFirma,
    guardarFirma,
    volver: location.state?.origen || "/evaluaciones",
  };
}
